<script lang="ts">
    import {page} from '$app/stores';
    import logoUrl from '$lib/assets/logo.svg';
    import paymentFailUrl from '$lib/assets/payment-fail.svg';
    import {onMount} from 'svelte';

    onMount(() => {
        setTimeout(function () {
            window.location.reload();
        }, 30000);
    });
</script>

<svelte:head>
    <title>{$page.status} — Q-Parser</title>
</svelte:head>

<div class="px-4 py-8 mx-auto space-y-6 max-w-prose">
    <div class="flex justify-center">
        <a href="/"><img src={logoUrl} alt="Q-Parser" /></a>
    </div>

    <h1 class="text-6xl text-center font-brand-bold">
        {#if $page.status === 404}
            404
        {:else}
            {$page.status} — Error
        {/if}
    </h1>

    <div class="prose text-center">
        {#if $page.error?.message}
            <p>
                {$page.error.message}
            </p>
        {:else if $page.status === 404}
            <p>Такой страницы не существует. Как вы тут оказались?</p>
        {:else}
            <p>Неизвестная ошибка &mdash; {$page.status}</p>
        {/if}
    </div>

    <div class="text-center">
        <a class="btn btn-green" href="/">Вернуться</a>
    </div>

    <div>
        <img src={paymentFailUrl} alt="Ошибка" />
    </div>
</div>
